import React from 'react';
import { Card, Typography } from 'antd';
import { Divider } from '@common/components/divider';
import { imagePath } from '@common/services/images-service';

const { Title } = Typography;

type EnvelopeProps = {
  text?: string;
  title: string;
  children?: JSX.Element;
  illustration?: string;
  footerLeft?: JSX.Element;
  footerRight?: JSX.Element;
};

// @TODO: Create a new Theme component with it
export const Envelope = ({
  text,
  title,
  children,
  footerLeft,
  footerRight,
  illustration,
}: EnvelopeProps) => {
  const hasAnyFooter = !!(footerLeft || footerRight);

  return (
    <>
      <div className="wk-envelope">
        <Card>
          <div className="wk-envelope-main">
            <div className="wk-envelope-header">
              {!!illustration && (
                <img
                  src={imagePath(`./illustrations/${illustration}.svg`)}
                  alt={illustration}
                />
              )}
              <Title level={2}>{title}</Title>
            </div>
            {text && <p>{text}</p>}
            {children}
          </div>
          {hasAnyFooter && (
            <>
              <Divider />
              <div className="wk-envelope-footer">
                <div>{footerLeft}</div>
                <div>{footerRight}</div>
              </div>
            </>
          )}
        </Card>
      </div>
      <style jsx>{`
        .wk-envelope {
          max-width: 592px;
        }
        .wk-envelope :global(.wk-divider) {
          margin: 16px 0 16px -16px;
          width: calc(100% + 32px);
        }
        .wk-envelope-header {
          text-align: center;
        }
        .wk-envelope-header img {
          margin-bottom: 28px;
        }
        .wk-envelope-main p {
          margin-bottom: 28px;
          font-size: 16px;
        }
        .wk-envelope-main {
          margin: 32px;
        }
        .wk-envelope-footer {
          display: flex;
          justify-content: space-between;
        }
        .wk-envelope :global(button + button) {
          margin-left: 16px;
        }
      `}</style>
    </>
  );
};
